export default "__VITE_PUBLIC_ASSET__a4d2c423__"